import { createContext, useContext, useState, useEffect } from "react";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { Purchases as PurchasesWeb } from '@revenuecat/purchases-js'; // Only needed if you want to handle success inline
import { Capacitor } from "@capacitor/core";


const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [name, setName] = useState(null);
  const [token, setToken] = useState(() => {
    // This callback only runs once, on the very first render.
    // If there's a valid token string in localStorage, return it.
    return localStorage.getItem("token") || null;
  });
  const [userId, setUserId] = useState(() => {
    // This callback only runs once, on the very first render.
    // If there's a valid userId string in localStorage, return it.
    return localStorage.getItem("userId") || null;
  });
  // finally: are we done hydrating from storage?
  const [isAuthReady, setIsAuthReady] = useState(false);


  // Optional: persist token across reloads
  useEffect(() => {
  //  const stored = localStorage.getItem("token");
  //  if (stored) setToken(stored);

  const storedToken  = localStorage.getItem("token");
  const storedUserId = localStorage.getItem("userId");
  if (storedToken)  setToken(storedToken);
  if (storedUserId) setUserId(storedUserId);
  setIsAuthReady(true);

  }, []);

  const login = (newToken, userId) => {
    setToken(newToken);
    setUserId(userId);
    localStorage.setItem("token", newToken);
    localStorage.setItem("userId", userId);
    localStorage.setItem("rc_app_user_id", userId)
  };

  const logout = () => {
    console.log("running auth logout");
    setToken(null);
    setUserId(null);
    //localStorage.removeItem("token");
    localStorage.clear();
    console.log("auth - cleared token and id");
/*
    if(Capacitor.isNativePlatform()){
      Purchases.logOut();
    } else {
      //PurchasesWeb.logOut(); log out not supported. change to anonymous user.
      console.log("web user. userId: "+ localStorage.getItem("userId") +" rcUser: "+ localStorage.getItem("rc_app_user_id") );
      const appUserId = PurchasesWeb.generateRevenueCatAnonymousAppUserId();
      PurchasesWeb.getSharedInstance().changeUser(appUserId);
      localStorage.setItem("userId", appUserId);
      localStorage.setItem("rc_app_user_id", appUserId);

      console.log("web user logged out new data - userId: "+ localStorage.getItem("userId") +" rcUser: "+ localStorage.getItem("rc_app_user_id") );
    }*/
  };

  return (
    <AuthContext.Provider value={{ token, userId, isLoggedIn: !!token, isAuthReady, login, logout, name, setName  }}>
      {children}
    </AuthContext.Provider>
  );
}

// Custom hook for easy access
export function useAuth() {
  return useContext(AuthContext);
}
